import { z } from "zod";
import { businessUnitTypeSchema } from "../auth/features.js";
import { pageOf, pageQuerySchema } from "../common/pagination.js";
import { localDateSchema, moneySchema, timestampSchema, uuidSchema } from "../common/primitives.js";
import { marketLedgerStatusSchema } from "./enums.js";
/**
 * Market gün kapanışı — SMM (Prompt 16, ADR 0016 §8). İstasyon × iş günü başına TEK kayıt ve TEK fiş (muhasebe grubu
 * × iş birimi satırlarıyla): `COGS:{grup}` borç / `INVENTORY:{grup}` alacak (net negatifse ters yön). Kapanıştan
 * SONRA işlenen satış hareketi o günün kapanışına geri yazılmaz; sonraki kapanışa "önceki günlerden" satırıyla girer.
 * Vardiya gün sonu akışı akaryakıt kapanışının yanında kendiliğinden tetikler; elle uç idempotenttir.
 */
export const marketDailyClosingLineSchema = z.object({
    accountingGroup: z.string(),
    businessUnit: businessUnitTypeSchema,
    saleValue: moneySchema.describe("Günün satış maliyeti (kuruş, pozitif)"),
    returnValue: moneySchema.describe("Günün iade / iptal maliyeti (kuruş, pozitif; SMM'yi azaltır)"),
    lateValue: moneySchema.describe("Önceki günlerden gelen (kapanıştan sonra işlenen) net SMM"),
    costAdjustment: moneySchema.describe("Kesin maliyet düzeltmesinin satılmış payı (+ SMM'yi artırır)"),
    cogs: moneySchema.describe("Net SMM = satış − iade + önceki günler + düzeltme"),
});
export const marketDailyClosingSchema = z.object({
    id: uuidSchema,
    companyId: uuidSchema,
    stationId: uuidSchema,
    stationName: z.string(),
    businessDate: localDateSchema,
    lines: z.array(marketDailyClosingLineSchema),
    cogsAmount: moneySchema.describe("Net SMM (negatif olabilir)"),
    movementCount: z.number().int(),
    lateMovementCount: z.number().int(),
    journalEntryId: uuidSchema.nullable(),
    ledgerStatus: marketLedgerStatusSchema,
    closedAt: timestampSchema,
    closedBy: uuidSchema.nullable(),
});
export const marketDailyClosingPageSchema = pageOf(marketDailyClosingSchema);
export const listMarketDailyClosingsQuerySchema = pageQuerySchema.extend({
    companyId: uuidSchema,
    stationId: uuidSchema.optional(),
    from: localDateSchema.optional(),
    to: localDateSchema.optional(),
});
export const closeMarketDaySchema = z.object({
    stationId: uuidSchema,
    businessDate: localDateSchema,
});
export const closeMarketDayResultSchema = z.object({
    created: z.boolean().describe("false → bu gün için kapanış zaten vardı (idempotent)"),
    closing: marketDailyClosingSchema,
    warnings: z.array(z.string()),
});
//# sourceMappingURL=closings.js.map